module.exports = __webpack_public_path__ + "static/img/celaeno_harpy.708afac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/celaeno_harpy.png
// module id = RRKK
// module chunks = 0